/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBillingInfoSuccessResponseData
 */
export interface UpdateBillingInfoSuccessResponseData {
    /**
     * 請求先情報変更メールの送信に成功したか
     * @type {boolean}
     * @memberof UpdateBillingInfoSuccessResponseData
     */
    isSentSuccess: boolean;
    /**
     * 請求先情報変更メールを送信したメールアドレス
     * @type {string}
     * @memberof UpdateBillingInfoSuccessResponseData
     */
    sentMailAddress: string;
}

export function UpdateBillingInfoSuccessResponseDataFromJSON(json: any): UpdateBillingInfoSuccessResponseData {
    return UpdateBillingInfoSuccessResponseDataFromJSONTyped(json, false);
}

export function UpdateBillingInfoSuccessResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBillingInfoSuccessResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isSentSuccess': json['is_sent_success'],
        'sentMailAddress': json['sent_mail_address'],
    };
}

export function UpdateBillingInfoSuccessResponseDataToJSON(value?: UpdateBillingInfoSuccessResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_sent_success': value.isSentSuccess,
        'sent_mail_address': value.sentMailAddress,
    };
}

